angular.module('controllers').controller('foodProductFamilyController', ['$scope', '$rootScope', '$controller', '$route', '$routeParams', '$location', 'Crud', 'Mqtt', '$sce',
	function ($scope, $rootScope, $controller, $route, $routeParams, $location, Crud, Mqtt, $sce) {

		$rootScope.path = '/food-product-family';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'food-product-family';
		$scope.pathTemplate = 'food/foodproductfamilies';
		$scope.title = 'Familii de produse';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'food_product_family_name';
		$scope.defaultItem = 10;
		$rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'food_product_family_name':{'label':'Nume', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);

		$scope.additionals['content_type'] = 'form-urlencoded';
    $scope.additionals['columnDisplay'] = 'goods_category_name';

		$scope.additionals['functionResult'] = function(ev, data) {
			if($scope.action == 'updatemultiple') {
					if (!angular.isUndefined($scope.modelsData)) {
							angular.forEach($scope.modelsData, function (item, key) {
									if (item.selected !== false) {
											if (!angular.isUndefined($scope.modelsData[key].food_product_family_name)) {
													$scope.modelsData[key].food_product_family_name = $scope.additionals['formatTextResult']($scope.modelsData[key].food_product_family_name);
											}
									}
							});
					}
			} else {
					if (!angular.isUndefined($scope.modelData.food_product_family_name)) {
						$scope.modelData.food_product_family_name = $scope.additionals['formatTextResult']($scope.modelData.food_product_family_name);
					}
			}
		}

  }]
);
